module.exports = __webpack_public_path__ + "media/packs/images/flags/KZ-d8f676b837470d841c6e9dfd300517e7.png";